import { _ as _objectSpread2, b as _objectWithoutProperties } from './_rollupPluginBabelHelpers-fb970440.js';
import { makeVar } from '@apollo/client';

var _excluded = ["proposerDetails", "proposerDetailsMeta"];
var workmen_proposal_init_state = {
  customerFetchRequiredOnLoad: false,
  intermediary: {
    code: '',
    intermediaryName: '',
    branchOfficeName: '',
    branchOfficeCode: '',
    fieldUserCode: '',
    fieldUserName: ''
  },
  isQuoteSaved: false,
  quoteData: null,
  coverData: null,
  planData: null,
  quoteNumber: '',
  quoteStatus: '',
  quotationType: '',
  memberType: '',
  prevInsuranceDetails: {
    prevInsurerName: '',
    prevPolicyMemNo: '',
    prevPolicyNo: '',
    prevPolicyStartDate: '',
    prevPolicyEndDate: '',
    prevPolicySI: '',
    claimAmount: '',
    totalPremium: '',
    prevClaimLodged: false
  },
  nomineeDetail: {
    relationship: '',
    nomineeName: '',
    nomineeDob: '',
    nameOfAppointee: '',
    relationshipWithInsured: '',
    appointeeRelationship: ''
  },
  premiumData: {
    discount: [],
    loading: [],
    netPremium: '',
    stampDuty: '',
    gst: '',
    totalPremium: ''
  },
  policyStartDate: '',
  policyTenure: '',
  otherOccupation: '',
  riskCategory: '',
  dob: '',
  quoteCreationDate: '',
  proposalNumber: '',
  proposalStatus: '',
  proposalPaymentType: '',
  isProposalApplicableForPayment: '',
  isPolicyIssued: false,
  existingPolicyNumber: '',
  isExistingEmployee: '',
  businessOfInsured: '',
  locationDetails: [],
  industryCategory: '',
  industryCategoryValue: '',
  industrySubCategory: '',
  endorsementNo: '',
  tacCode: '',
  industrySubCategoryValue: '',
  policyType: '',
  policyTypeValue: '',
  locationType: '',
  locationTypeValue: '',
  allIndiaBasisDescription: '',
  addressLine1: '',
  addressLine2: '',
  addressLine3: '',
  landmark: '',
  pincode: '',
  stateLocation: '',
  loading: '',
  discount: '',
  proposerDetailsMeta: {
    crn: '',
    isNewCustomer: null,
    ifscCode: '',
    bankName: '',
    branchName: '',
    bankAcno: '',
    accountHolderName: '',
    micrCode: ''
  },
  proposerDetails: {
    id: '',
    customerType: '',
    title: '',
    gender: '',
    firstName: '',
    middleName: '',
    lastName: '',
    fullName: '',
    occupation: '',
    maritalStatus: '',
    nationality: '',
    proposerDOB: '',
    panNumber: '',
    idProofType: '',
    idProofNumber: '',
    permAddressLine1: '',
    permAddressLine2: '',
    permAddressLine3: '',
    permLandmark: '',
    permPincode: '',
    permCityTownVillage: '',
    permDistrict: '',
    permState: '',
    permCommAddressYN: false,
    commAddressLine1: '',
    commAddressLine2: '',
    commAddressLine3: '',
    commLandmark: '',
    commPincode: '',
    commCityTownVillage: '',
    commDistrict: '',
    commState: '',
    mobileNo: '',
    emailID: '',
    orgName: '',
    orgType: '',
    contactName: '',
    regNumber: '',
    tanNumber: '',
    gstNumber: '',
    phoneNo: '',
    altPhoneNo: '',
    altMobileNo: '',
    faxNo: '',
    employeeNumber: ''
  },
  reviewAndConfirmTabDetails: {
    proposalPaymentType: '',
    isProposalCreated: false,
    documentDetails: []
  },
  policy: {
    startDate: '',
    endDate: '',
    time: ''
  },
  issuedPolicyData: {
    policyNo: '',
    receiptID: [],
    referenceNumber: '',
    digiLink: '',
    displayMessage: '',
    additionalMessage: ''
  },
  premiumDetails: {
    termsAndConditions: false,
    paymentMethod: '',
    payerType: '',
    onlinePayment: {
      transactionId: '',
      isTransactionIdVerified: null
    },
    //CN15
    receiptPayment: {
      receiptId: '' // isReceiptIdVerified: null,

    },
    cdWallet: {
      cdAccountNo: '',
      cdAccountBalance: ''
    },
    cheque: [],
    demandDraft: []
  }
};
var is_India_Basis = {
  isIndiaBasis: false
};
var buyWorkmenPolicyVar = makeVar(workmen_proposal_init_state);
var initBuyWmcPolicyVar = function initBuyWmcPolicyVar() {
  buyWorkmenPolicyVar(workmen_proposal_init_state);
};
makeVar(is_India_Basis);
var resetProposerDetails = function resetProposerDetails(data) {
  var initObj = {},
      initMetaObj = {};
  Object.keys(buyWorkmenPolicyVar().proposerDetails).forEach(function (v) {
    if (data !== null && data !== void 0 && data.proposerDetails[v]) {
      initObj[v] = data.proposerDetails[v];
    } else {
      if (v === 'permCommAddressYN') {
        initObj[v] = false;
      } else {
        initObj[v] = '';
      }
    }
  });
  Object.keys(buyWorkmenPolicyVar().proposerDetailsMeta).forEach(function (v) {
    if (data !== null && data !== void 0 && data.proposerDetailsMeta[v]) {
      initMetaObj[v] = data.proposerDetailsMeta[v];
    } else {
      initMetaObj[v] = '';
    }
  });
  buyWorkmenPolicyVar(_objectSpread2(_objectSpread2({}, buyWorkmenPolicyVar()), {}, {
    proposerDetails: initObj,
    proposerDetailsMeta: initMetaObj
  }));
};
var updateBuyWcPolicyVar = function updateBuyWcPolicyVar(data) {
  var proposerDetails = data.proposerDetails,
      proposerDetailsMeta = data.proposerDetailsMeta,
      rest = _objectWithoutProperties(data, _excluded);

  if (proposerDetails && proposerDetailsMeta) {
    buyWorkmenPolicyVar(_objectSpread2(_objectSpread2({}, buyWorkmenPolicyVar()), {}, {
      proposerDetails: _objectSpread2(_objectSpread2({}, buyWorkmenPolicyVar().proposerDetails), proposerDetails),
      proposerDetailsMeta: _objectSpread2(_objectSpread2({}, buyWorkmenPolicyVar().proposerDetailsMeta), proposerDetailsMeta)
    }, rest));
  } else if (proposerDetails && !proposerDetailsMeta) {
    buyWorkmenPolicyVar(_objectSpread2(_objectSpread2({}, buyWorkmenPolicyVar()), {}, {
      proposerDetails: _objectSpread2(_objectSpread2({}, buyWorkmenPolicyVar().proposerDetails), proposerDetails)
    }, rest));
  } else if (!proposerDetails && proposerDetailsMeta) {
    buyWorkmenPolicyVar(_objectSpread2(_objectSpread2({}, buyWorkmenPolicyVar()), {}, {
      proposerDetailsMeta: _objectSpread2(_objectSpread2({}, buyWorkmenPolicyVar().proposerDetailsMeta), proposerDetails)
    }, rest));
  } else {
    buyWorkmenPolicyVar(_objectSpread2(_objectSpread2({}, buyWorkmenPolicyVar()), rest));
  }
};

export { buyWorkmenPolicyVar as b, initBuyWmcPolicyVar as i, resetProposerDetails as r, updateBuyWcPolicyVar as u };
